import { StyledDialog } from "@/shared/ui";
import EditDialog from "./EditDialog/EditDialog";

interface IProps {
  dialogId?: string;
  title?: string;
  isOpen: boolean;
  onClose: () => void;
}

const Container = ({ isOpen, ...restProps }: IProps) => {
  return (
    <StyledDialog maxWidth="md" open={isOpen} onClose={restProps.onClose}>
      <EditDialog {...restProps} />
    </StyledDialog>
  );
};

export default Container;
